import React from 'react';
import "../styles/about.css";
import BioSection from './BioSection';
import SkillsSection from './SkillsSection';
import ExperienceSection from './ExperienceSection';
import EducationSection from './EducationSection';
import Footer from "./Footer";
import CertificationsSection from './CertificationsSection';
// import TransitionEffect from './TransitionEffect';


const About = () => {

    return (
        <>
            {/* <TransitionEffect /> */}
            <div className='about_container animation'>
                <h1 className='about_title'>I’m Soumyajit Pan</h1>
                <BioSection />
                <SkillsSection />
                <ExperienceSection />
                <EducationSection />
                <CertificationsSection />
                <Footer />
            </div>
        </>
    );
};

export default About;